(() => {
  const button = document.querySelector('.kz-back-to-top');
  if (!button) return;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let scheduled = false;

  const update = () => {
    scheduled = false;
    const footer = document.querySelector('footer.footer');
    const height = window.innerHeight;
    const overlay = document.querySelector('dialog[open], #kz-consent:not([hidden]), .AirReviews-Modal');
    const overlayVisible = overlay && overlay.getClientRects().length > 0 && getComputedStyle(overlay).visibility !== 'hidden';
    const drawerOpen = /(?:mini-cart|menu-drawer|menu-mobile|search-modal)--(?:open|opening)/.test(document.body.className);
    button.hidden = !footer || window.scrollY < height || footer.getBoundingClientRect().top > height * 1.5 || overlayVisible || drawerOpen;
    if (button.hidden) return;

    let clearance = 0;
    document.querySelectorAll('.product-sticky-cart, mobile-dock').forEach((element) => {
      const bounds = element.getBoundingClientRect();
      const style = getComputedStyle(element);
      if (bounds.height > 0 && bounds.top < height && bounds.bottom > 0 && style.visibility !== 'hidden' && Number(style.opacity) > 0) {
        clearance = Math.max(clearance, height - bounds.top);
      }
    });
    button.style.setProperty('--kz-top-clearance', `${Math.ceil(clearance)}px`);
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  };

  button.addEventListener('click', () => {
    document.getElementById('MainContent')?.focus({ preventScroll: true });
    window.scrollTo({ top: 0, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
  });
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('transitionend', schedule);
  new MutationObserver(schedule).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  const overlayObserver = new MutationObserver(schedule);
  document.querySelectorAll('dialog, #kz-consent, animate-sticky, mobile-dock').forEach((element) => {
    overlayObserver.observe(element, { attributes: true, attributeFilter: ['open', 'hidden', 'animate', 'class'] });
  });
  const resizeObserver = new ResizeObserver(schedule);
  document.querySelectorAll('footer.footer, .product-sticky-cart, mobile-dock').forEach((element) => resizeObserver.observe(element));
  schedule();
})();
